module.exports = __webpack_public_path__ + "img/jingyingyusuan.08cdcba2.png";